import apiUrl from './apiUrl';

/**
 * Get exclusive api url
 * @memberof module:helpers/urlHelper
 * @function
 * @example
 * exclusiveUrl
 * // => 'http://api.local.host:8089/_exclusive'
 */
const exclusiveUrl = `${apiUrl}/_exclusive`;

export default exclusiveUrl;
